<template>
    <div ref="reportModal" id="reportModal" class="modal fade" role="dialog" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-calendar-preview modal-post-anything">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="close-modal" data-dismiss="modal">
                        <div class="row">
                            <div class="col-md-10 col-sm-10 col-xs-8 title-preview">
                                <h4 class="modal-title" v-html="title"></h4>
                            </div>
                            <div class="col-md-2 col-sm-2 col-xs-4 text-right">
                                <a @click.prevent="send"><i class="fa fa-times-circle fa-2x"></i> <span class="close-text">{{ $i18n.general.close }}</span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="alert alert-info" role="alert" v-if="error && !sent">
                        {{error}}
                    </div>
                    <div class="row" v-if="!sent">
                        <div class="col-md-12">
                            <textarea ref="defaultTextArea" v-model="msg" class="form-control" v-bind:placeholder="$i18n.content_planner.content_calendar.describe_your_problem"></textarea>
                        </div>
                    </div>
                    <div class="row" v-if="sent">
                        <div class="alert alert-success">
                            {{ $i18n.content_planner.content_calendar.thanks_for_report }}
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="row text-right">
                        <div class="col-xs-12 text-left" v-if="!sent">
                            <button type="button" class="btn btn-default" :disabled="sending" @click.prevent="send">{{ $i18n.general.send }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                id: null,
                title: null,
                msg: '',
                error: false,
                sent: false,
                sending: false,
            };
        },

        methods: {
            openDialog() {
                this.$nextTick(function() {
                    $(this.$refs.reportModal).modal('show');
                }.bind(this));
            },

            closeDialog() {
                $(this.$refs.reportModal)
                    .on('hidden.bs.modal', function() {
                        this.active = false;
                    }.bind(this))
                    .modal('hide');
            },

            reportProblem(type, id) {
                this.id = id;
                this.msg = '';
                this.sent = false;
                this.sending = false;

                switch(type) {
                    case 'post':
                        this.title = this.$i18n.content_planner.content_calendar.report_problem_post;
                        break;
                    case 'content':
                        this.title = this.$i18n.content_planner.content_calendar.report_problem_content;
                        break;
                    default:
                        this.title = this.$i18n.content_planner.content_calendar.report_problem;
                }
                this.openDialog();
            },
            send() {
                if (this.sending) {
                    return;
                }

                this.sending = true;

                if (this.msg.trim() == '') {
                    this.error = this.$i18n.validation.required.replace(':attribute', 'message');
                    this.sending = false;
                    return;
                }

                this.error = '';

                let metadata= {
                    related_id: this.id,
                    message: this.msg
                };

                this.$http.post('intercom/report', metadata).then(function(response){
                    this.sent=true;
                    setTimeout(function() {this.closeDialog()}.bind(this), 2000);
                    this.sending = false;
                }.bind(this)).catch(error => {});
            },
        },

        mounted: function() {
            this.title = this.$i18n.content_planner.content_calendar.report_problem;

            eventHub.$on('report-problem', function(type, id) {this.reportProblem(type, id);}.bind(this));
        }

    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/report.vue